import { render, staticRenderFns } from "./StockWatch.vue?vue&type=template&id=75c5aee8&scoped=true"
import script from "./StockWatch.vue?vue&type=script&lang=js"
export * from "./StockWatch.vue?vue&type=script&lang=js"
import style0 from "./StockWatch.vue?vue&type=style&index=0&id=75c5aee8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75c5aee8",
  null
  
)

export default component.exports